/**
 * Reports webshop conversions to VWO (Wingify) as Data360 events. Consent is
 * VWO's own (handlesOwnConsent), not EpmsAnalytics' - see
 * docs/plans/consent-unification.md.
 */
export class VwoProvider {
    constructor() {
        this.handlesOwnConsent = true;
        this.experimentArms = {};
        this.currency = "NOK";
    }
    setCurrency(code) {
        this.currency = code;
    }
    /** The arms EPMS assigned this subject, as VWO visitor attributes. */
    setExperimentArms(arms) {
        this.experimentArms = arms;
        this.pushToVwo(["visitor", arms]);
    }
    onPurchaseSuccessful(order) {
        this.trackEvent("purchase", {
            order_id: order.uuid,
            revenue: order.summary.totalPrice,
            currency: this.currency,
        });
    }
    onAddToCart(items) {
        this.trackEvent("add_to_cart", { item_count: items.length });
    }
    onRemoveFromCart(items) {
        this.trackEvent("remove_from_cart", { item_count: items.length });
    }
    onViewCart(items) {
        this.trackEvent("view_cart", { item_count: items.length });
    }
    onBeginCheckout(items) {
        this.trackEvent("begin_checkout", { item_count: items.length });
    }
    onCartChange(cartUpdate) {
        var _a, _b;
        this.trackEvent("cart_change", {
            item_count: (_b = (_a = cartUpdate.newOrderLines) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
        });
    }
    setAllowTracking(_value) {
        // Intentionally empty: consent reaches VWO through the consent bridge in
        // VwoAnalyticsProvider, which detects the visitor's actual consent tool.
    }
    trackEvent(eventName, properties) {
        this.pushToVwo([
            "event",
            eventName,
            Object.assign(Object.assign({}, properties), this.experimentArms),
        ]);
    }
    pushToVwo(payload) {
        var _a;
        (_a = getVwoQueue()) === null || _a === void 0 ? void 0 : _a.push(payload);
    }
}
/** The queue VwoAnalyticsProvider sets up, taken over by the tag on load. */
function getVwoQueue() {
    const queue = window.Wingify;
    return queue && typeof queue.push === "function" ? queue : null;
}
